import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useProfile } from "@/hooks/useProfile";
import { useAuth } from "@/hooks/useAuth";
import { Wordmark } from "@/components/Wordmark";
import { StatusBanner } from "@/components/StatusBanner";
import { ROUTES } from "@/constants/routes";

export function ProfileErrorState({ message }) {
  const { retry } = useProfile();
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const handleSignOut = async () => {
    setBusy(true);
    await signOut().catch(() => {});
    navigate(ROUTES.login, { replace: true });
  };

  return (
    <div data-testid="profile-error-state" className="flex min-h-screen items-center justify-center bg-background px-6">
      <div className="w-full max-w-md space-y-6">
        <Wordmark />
        <h1 className="font-serif text-3xl tracking-tight">We couldn't load your profile.</h1>
        <StatusBanner>{message || "Your profile is temporarily unavailable."}</StatusBanner>
        <div className="flex flex-wrap gap-3">
          <button type="button" onClick={retry} data-testid="retry-button" className="mw-btn mw-btn-primary">
            Try again
          </button>
          <button type="button" onClick={handleSignOut} disabled={busy} data-testid="profile-error-signout-button" className="mw-btn mw-btn-ghost">
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
